module.exports = __webpack_public_path__ + "img/6.8be40fc8.svg";